<template>
  <div id="pageContent">
    <div class="borderBox">
      <div v-if="readyToWork">
        <div class="fl filterByDateList">
          <div>
            <label >Дата от</label>
            <input type="date" v-model="DateBegin">
          </div>
          <div>
            <label >Дата до</label>
            <input type="date" v-model="DateEnd">
          </div>
          <div class="button" v-on:click="getList">Показать</div>
          <div>
            <label >Фильтр списка по полю:</label>
            <select v-model="filterKey">
              <option value="FIOAgent">Фио агента</option>
              <option value="Phone">Телефон</option>
            </select>
          </div>
          <div>
            <label>Значение фильтра</label>
            <input type="text" v-model="filterValue">
          </div>
        </div>
        <ul id="editIncomeListWrap">
          <li class="fl">
            <div>Дата звонка</div>
            <div>Тема звонка</div>
            <div>Уточнение</div>
            <div>Откда о нас узнали</div>
            <div>Телефон</div>
            <div>Фио Оператора</div>
            <div ></div>
          </li>
          <editLeadIncome v-for="lead in filterList" :data="lead"></editLeadIncome>
        </ul>
      </div>
      <div class="loaderWrap" v-else>
        <loader ></loader>
      </div>
    </div>
  </div>
</template>

<script>

  import DataForInput from '@/gavnoCode/longFormOptions';

  function formatDate(date){
    var values = [date.getDate(), date.getMonth() + 1];
    for (var id in values) {
      values[ id ] = values[ id ].toString().replace(/^([0-9])$/, '0$1');
    }
    return date.getFullYear() + '-' + values[1] + '-' + values[0];
  };

  var dtDateDesc = function (d1, d2) {
    return (d1.DateModify.toLowerCase() < d2.DateModify.toLowerCase()) ? 1 : -1;
  };


  // escapes RegExp special characters
  const escapePattern = s => s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

  // converts ILIKE pattern to a RegExp object
  const ilikeToRegExp = pattern =>
    new RegExp(
      `^${escapePattern(pattern)}$`
      // convert ILIKE wildcards, don't match escaped
      .replace(/(?<![\\])%/g, '.*')
      .replace(/(?<![\\])_/g, '.')
      // replace ILIKE escapes
      .replace(/\\%/g, '%')
      .replace(/\\_/g, '_'),
      'i'
    );


  export default {
    name: "editIncome",
    data: function () {
      return {
        incomeList: [],
        readyToWork: true,
        DateBegin: '',
        DateEnd: '',
        filterKey:'',
        filterValue:'',
      }
    },
    components:{
      loader: () => import('@/components/loader'),
      editLeadIncome: () => import('@/components/forms/editLeadIncome')
    },
    methods:{
      getList(){
        this.readyToWork = false;
        this.$myApi.SendRequest({
          action:'Operator_getIncomeList',
          DateBegin: this.DateBegin,
          DateEnd: this.DateEnd,
        }, this, 'getIncomeList', false)
          .then((resp) => {
            this.incomeList = resp.sort(dtDateDesc);
            this.readyToWork = true;
          })
          .catch((resp) => {
            console.log(resp);
            this.readyToWork = true;
          });
      },
      updateLibWTF: function () {
        this.$myApi.getWTFlib().then((result) => {
          let sortTemp = result.map(function (el, i) {
            return { index: i, value: el.nameOption.toLowerCase() };
          });

          sortTemp.sort(function(a, b) {
            if (a.value > b.value) {return 1;}
            if (a.value < b.value) {return -1;}
            return 0;
          });
          let sortArr = sortTemp.map(function(el){
            return result[el.index];
          });
          DataForInput.WHERE_TO_FIND_US.selectOption = sortArr;
        }).catch(e => {
          alert('Ошибка :' + e);
        });
      }
    },
    computed:{
      filterList(){
        if (this.filterValue == '' || this.filterKey == '') {
          return this.incomeList;
        }
        if (this.filterValue.length > 3) {
          return this.incomeList.filter((element)=>{
            return ilikeToRegExp('%' + this.filterValue + '%').test(element[this.filterKey]);
          });
        } else {
          return this.incomeList;
        }
      }
    },
    mounted(){
      this.updateLibWTF();
      var date = new Date();
      date.setDate(date.getDate());
      this.DateEnd = formatDate(date);
      this.DateBegin = formatDate(date);
      this.getList();
    }
  }
</script>

<style >
.borderBox{width: 1600px;min-height: 300px;}
.loaderWrap{min-height: 66vh;height: 1px;}
#editIncomeListWrap, #editIncomeListWrap li{list-style: none;margin: 0;padding: 0}
#editIncomeListWrap li {justify-content: flex-start}
#editIncomeListWrap li div{padding: 5px;box-shadow: inset 0 0 1px 1px green;width: 150px;}
#editIncomeListWrap li div:nth-child(2){width: 300px;}
#editIncomeListWrap li div:nth-child(3){width: 300px;}
#editIncomeListWrap li div:nth-child(4){width: 300px;}
.filterByDateList{justify-content: flex-start;align-items: center;}
.filterByDateList div{margin-right: 10px;}
</style>
